
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
/**
 * This store assumes ONE active flow at a time.
 */

const initialState = {
  error: null,
  carData: null,
  carPlateno: null,
  hasVehicleHomeDelivery: false,
  deliveryLocation: {address:"", city: "", googleMapsURL:"", garageCategory:""},
  hasOnlyCalendar: false,
  deliveryStatusByPlate: {},
  pickUpPoint: null,
  uiStep: null,
  flowStep: null,
  canFlowStepUndo: false,
  lockNext: true,
  flowId: null,
  apiOptions: [],
  selectedOption: null,
  deliveryCosts: null,
  isVehicleDeliverySelected: false,
  interimVehiclePlate: null,
  deliveryAddress: { street: "", number: "", area: "", zipCode: "" },
  bookingCalendarOptions: [],
  isPreferred: false,
  selectedCalendarOption: { selectedDate: null, selectedSlots: [] },
  additionalComments: null,
  summaryObject: null,
};

export const useDeliveryFlowStore = create(
  persist(
    (set, get) => ({
      ...initialState,

      // -------- lifecycle 
      reset: () => {
        // resets in-memory state
        set((state) => ({
          ...initialState,
          deliveryStatusByPlate: state.deliveryStatusByPlate,
        }));
        // also clears persisted values
        get().clearPersistedCarData();
      },


      resetFields: (fields) => {
        const patch = {};
        fields.forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(initialState, key)) {
            patch[key] = initialState[key];
          }
        });
        set(patch);
        if (fields.includes("carData")) {
          get().clearPersistedCarData();
        }
      },

      // -------- initialization / api hydration
      setField: (key, value) => set({ [key]: value }),

      setLockNext: (lockNext) => set({ lockNext }),
      setError: (error) => set({ error }),
      setCarData: (carData) => set({ carData }),
      setDeliveryStatus: (plateno, status) =>
        set((state) => ({
          deliveryStatusByPlate: {
            ...state.deliveryStatusByPlate,
            [plateno]: status,
          },
        })),
      setCarPlateno: (carPlateno) => set({ carPlateno }),
      setHasVehicleHomeDelivery: (hasVehicleHomeDelivery) => set({ hasVehicleHomeDelivery }),
      setDeliveryLocation: (deliveryLocation) => set({ deliveryLocation }),
      setHasOnlyCalendar: (hasOnlyCalendar) => set({ hasOnlyCalendar }),
      setUiStep: (uiStep) => set({ uiStep }),
      setFlowStep: (flowStep) => set({ flowStep }),
      setCanFlowStepUndo: (canFlowStepUndo) => set({ canFlowStepUndo }),
      setFlowId: (flowId) => set({ flowId }),
      setApiOptions: (apiOptions) => set({ apiOptions }),
      setSelectedOption: (selectedOption) => set({ selectedOption }),
      setPickUpPoint: (pickUpPoint) => set({ pickUpPoint }),
      setDeliveryCosts: (deliveryCosts) => set({ deliveryCosts }),
      setIsVehicleDeliverySelected: (isVehicleDeliverySelected) => set({ isVehicleDeliverySelected }),
      setInterimVehiclePlate: (interimVehiclePlate) => set({ interimVehiclePlate }),
      setDeliveryAddress: (deliveryAddress) => set({ deliveryAddress }),
      setBookingCalendarOptions: (bookingCalendarOptions) => set({ bookingCalendarOptions }),
      setIsPreferred: (isPreferred) => set({ isPreferred }),
      setSelectedCalendarOption: (selectedCalendarOption) => set({ selectedCalendarOption }),
      setAdditionalComments: (additionalComments) => set({ additionalComments }),
      setSummaryObject: (summaryObject) => set({ summaryObject }),

      // -------- stepper
      incrementStep: () => set((state) => ({ step: state.step + 1 })),
      decreaseStep: () => set((state) => ({ step: state.step - 1 })),

      clearPersistedCarData: () => {
        set({ carData: initialState.carData });

        sessionStorage.removeItem("delivery-flow-store");
      },
    }),
    {
      name: "delivery-flow-store",
      storage: createJSONStorage(() => sessionStorage),

      partialize: (state) => ({ carData: state.carData }),
      
    }
  )
);
